import { cn } from "@/lib/utils";

export function ShareIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-5.5 w-[17px] text-white", className)}
      viewBox="0 0 17 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 13.922c-.501 0-.905-.404-.905-.879V4.315l.079-1.3-.51.659-1.16 1.23a.787.787 0 01-.598.264c-.43 0-.79-.316-.79-.765 0-.228.087-.404.254-.562L7.806 1.02c.228-.23.457-.317.694-.317.237 0 .457.088.694.317l2.936 2.82a.758.758 0 01.246.563c0 .449-.36.765-.791.765a.8.8 0 01-.598-.264l-1.151-1.23-.51-.66.07 1.301v8.728a.891.891 0 01-.896.879zm-5.071 7.101c-1.943 0-2.98-1.02-2.98-2.953V9.51c0-1.925 1.037-2.953 2.98-2.953h2.47v1.96H3.595c-.774 0-1.187.395-1.187 1.195v8.156c0 .809.413 1.196 1.187 1.196h9.808c.765 0 1.187-.387 1.187-1.196V9.712c0-.8-.422-1.195-1.187-1.195h-2.311v-1.96h2.478c1.952 0 2.98 1.028 2.98 2.953v8.56c0 1.925-1.028 2.953-2.98 2.953H3.43z"
        fill="currentColor"
      />
    </svg>
  );
}
